export default function trimSymbols(value: string, symbols: string): string {
  const regex = new RegExp(`^[${symbols}]+|[${symbols}]+$`, 'g');
  return value.replace(regex, '');
}
